import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CommunityMembers } from 'src/app/models/identity/community-member.model';
import { CommunityDisplay } from 'src/app/models/users/welcome/community-display';
import { AccountsService } from 'src/app/services/identity/accounts.service';
import { CommunityService } from 'src/app/services/identity/community.service';

@Component({
    selector: 'app-widget-invite',
    templateUrl: './widget-invite.component.html',
    styleUrls: ['widget-invite.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class WidgetInviteComponent implements OnInit, OnDestroy {
    private destroy$ = new Subject<void>();
    public isLoading: boolean = true;

    public numberOfAvatars: number = 5;

    public communities: CommunityDisplay[] = [];
    public selectedCommunity: CommunityDisplay | null = null;

    public modalDisplay = false;

    constructor(readonly accountService: AccountsService, readonly router: Router, readonly communityService: CommunityService) { }

    ngOnInit() {
        this.populateManagedCommunities();
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }

    // get managed communities
    public populateManagedCommunities() {

        const communitiesWithRoles = this.accountService.getCommunitiesManagedByUser()
            .sort((a, b) => {
                if (a.isPrimary) return -1;
                if (b.isPrimary) return 1;
                return a.displayName.localeCompare(b.displayName);
            });

        this.communities = communitiesWithRoles.map(c => ({
            id: c.id,
            isPrimary: c.isPrimary,
            name: c.displayName,
            members: [],
            memberCount: 0
        }));

        // select primary community
        if (this.communities.length > 0) {
            this.selectCommunity(this.communities[0]);
        }
    }

    public populateCommunity(community: CommunityDisplay) {
        this.isLoading = true;
        this.communityService.getCommunityMembers(
            community.id,
            1,
            this.numberOfAvatars,
            'CreatedAt',
            'desc'
        )
        .pipe(takeUntil(this.destroy$))
        .subscribe(response => {
            community.members = response.members;
            community.memberCount = response.totalCount;
            this.isLoading = false;
        });
    }

    public selectCommunity(community: CommunityDisplay) {
        this.selectedCommunity = community;
        if (!community.members || community.members.length === 0) {
            this.populateCommunity(community);
        }
    }

    public emptyCommunities() {
        this.communities.forEach(community => {
            community.members = [];
            community.memberCount = 0;
        });
    }

    public openModal() {
        this.modalDisplay = true;
    }

    public closeModal(event: boolean) {
        if (event) { //refresh to have new member count
            this.emptyCommunities();
            this.populateCommunity(this.selectedCommunity);
        }
        this.modalDisplay = false;
    }
}
